function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione05Popup0301Ico05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.32 76.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.86,73.95v-4.47h26.83v5.96M36.69,69.48v-2.71c0-6.33-4.4-11.87-10.6-13.12-.88-.18-1.83-.32-2.85-.41-1.4-.13-2.72-.72-3.71-1.71l-6.48-6.48c-1.38-1.38-3.63-1.64-5.14-.41-1.73,1.42-1.83,3.98-.29,5.53l10.37,10.37M9.02,44.03l-1.78-10.54c-.21-1.58-1.55-2.76-3.15-2.76h0c-1.75,0-3.17,1.42-3.17,3.17v19.7c0,1.58.63,3.1,1.75,4.22l11.67,11.67M72.46,73.95v-4.47h-26.83v5.96M45.63,69.48v-2.71c0-6.33,4.4-11.87,10.6-13.12.88-.18,1.83-.32,2.85-.41,1.4-.13,2.72-.72,3.71-1.71l6.48-6.48c1.38-1.38,3.63-1.64,5.13-.41,1.74,1.42,1.83,3.98.29,5.53l-10.37,10.37M73.3,44.03l1.78-10.54c.21-1.58,1.55-2.76,3.15-2.76h0c1.75,0,3.17,1.42,3.17,3.17v19.7c0,1.58-.63,3.1-1.75,4.22l-11.67,11.67",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5,8.37c0,4.12-3.34,7.45-7.45,7.45s-7.45-3.33-7.45-7.45,3.34-7.45,7.45-7.45,7.45,3.33,7.45,7.45ZM33.71,20.29c0,4.12,3.34,7.45,7.45,7.45s7.45-3.33,7.45-7.45-3.34-7.45-7.45-7.45-7.45,3.33-7.45,7.45Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.59,39.67v8.94M30.72,39.67v8.94M57.55,45.63v-7.63c0-2.57-1.64-4.84-4.08-5.66l-4.87-1.62-7.45,7.45-7.45-7.45-4.87,1.62c-2.43.81-4.08,3.09-4.08,5.66v7.63",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.82,8.37c0,4.12,3.34,7.45,7.45,7.45s7.45-3.33,7.45-7.45S27.39.91,23.27.91s-7.45,3.33-7.45,7.45Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.74,21.78l-4.47,4.47-7.45-7.45-4.87,1.62c-2.17.72-3.7,2.61-4.01,4.83M75.37,25.25c-.31-2.22-1.84-4.1-4.01-4.83l-4.87-1.62-7.45,7.45-4.47-4.47M69.48,27.74v5.96M12.84,27.74v5.96",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.83px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione05Popup0301Ico05);
export default __webpack_public_path__ + "static/media/sezione-05-popup-03-01-ico-05.da892702fb921d3972d99f0e0b6616e6.svg";
export { ForwardRef as ReactComponent };